module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid bg-dark"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3 col-lg-2 p-0"
  }, [_c('auction-select')], 1), _vm._v(" "), _c('div', {
    staticClass: "col text-center py-3 p-0"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('img', {
    attrs: {
      "id": "logo",
      "src": "/static/img/logo.png"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 py-4 text-right"
  }, [_c('user-menu', {
    staticClass: "hidden-xs-down"
  })], 1), _vm._v(" "), _c('flash-messages-list')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39fd7732"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/includes/AuctionHeader.vue
// module id = 1295
// module chunks = 1